module.exports = __webpack_public_path__ + "media/new/pay-myetherewallet-9e0c6f26.svg";